import React, { useState, useRef, useEffect } from "react"

import styles from "./videoPlayer.module.scss"
import PlayIcon from "../images/icon-play.svg"
import PauseIcon from "../images/icon-pause.svg"

const Video = props => {
  const videoRef = useRef(null)
  const [videoPlaying, setPlayingState] = useState(false)
  const sourceAttrs = {
    src: props.src,
    type: props.type,
  }

  function play() {
    videoRef.current.play()
    setPlayingState(true)
  }

  function pause() {
    videoRef.current.pause()
    setPlayingState(false)
  }

  function togglePlayPause() {
    return videoRef.current.paused || videoRef.current.ended ? play() : pause()
  }

  useEffect(() => {
    const node = videoRef.current
    function videoEnded() {
      pause()
      videoRef.current.load()
    }
    node.addEventListener("ended", videoEnded)

    return () => {
      node.removeEventListener("ended", videoEnded)
    }
  })

  return (
    <div
      className={`${styles.videoContainer} ${styles.hasControls} ${
        videoPlaying ? styles.isPlaying : null
      }`}
    >
      <video // eslint-disable-line jsx-a11y/media-has-caption
        className={styles.video}
        ref={videoRef}
        poster={props.poster}
      >
        <source {...sourceAttrs} />
      </video>
      <button onClick={togglePlayPause} className={styles.playPause}>
        <span className="screen-reader-only">Toggle Play/Pause</span>
        <div role="presentation">
          <div className={styles.iconPlay}>
            <PlayIcon />
          </div>
          <div className={styles.iconPause}>
            <PauseIcon />
          </div>
        </div>
      </button>
    </div>
  )
}

export default Video
